import { MediaEntityType } from '@ancon/wildcat-types'

function getBaseURL(): string {
  if (!process.env.NEXT_PUBLIC_MEDIA_CDN_URL) {
    throw new Error(
      'NEXT_PUBLIC_MEDIA_CDN_URL is not defined in the client environment',
    )
  }

  return process.env.NEXT_PUBLIC_MEDIA_CDN_URL
}

export default function getMediaImageCdnUrl(
  tenantId: string,
  imageId: string,
  mediaEntityType: MediaEntityType,
  mediaEntityId: string,
  size?: string,
): string {
  const mediaCdnBaseUrl = getBaseURL()
  const mediaEntityTypeName = MediaEntityType[mediaEntityType]

  const mediaCdnUrl = `${mediaCdnBaseUrl}/${tenantId}/${mediaEntityTypeName}/${mediaEntityId}/${imageId}`

  if (size) {
    return `${mediaCdnUrl}-${size}`
  }

  return mediaCdnUrl
}
